import ReactDOM from 'react-dom';
import Card from './Card';
import Icon from '@mui/material/Icon';

import './WrapperModal.scss';

const Backdrop = (props) => {
	return (
		<div
			className='wrapper-modal-backdrop'
			// onClick={props.onDismiss}
		/>
	);
};
const ModalOverlay = ({
	children,
	onDismiss,
	modalControls = true,
	topAnchored = false,
	defaultWidth
}) => {
	const modalClassName = `wrapper-modal text-center${
		topAnchored ? ' top-anchored' : ''
	}`;
	return (
		<Card
			className={modalClassName}
			style={{ width: defaultWidth }}
		>
			{modalControls && (
				<div className='modal-controls'>
					<Icon
						onClick={onDismiss}
						className='modal-control-icon'
					>
						close
					</Icon>
				</div>
			)}
			<div>{children}</div>
		</Card>
	);
};

const WrapperModal = ({
	children,
	onConfirm,
	onDismiss,
	withBackdrop = true,
	modalControls = true,
	topAnchored = false,
	defaultWidth
}) => {
	return (
		<>
			{withBackdrop &&
				ReactDOM.createPortal(
					<Backdrop onDismiss={onDismiss} />,
					document.getElementById('backdrop-root')
				)}
			{ReactDOM.createPortal(
				<ModalOverlay
					onConfirm={onConfirm}
					onDismiss={onDismiss}
					modalControls={modalControls}
					topAnchored={topAnchored}
					defaultWidth={defaultWidth}
				>
					{children}
				</ModalOverlay>,
				document.getElementById('overlay-root')
			)}
		</>
	);
};

export default WrapperModal;
